import { render, staticRenderFns } from "./EnrollmentFieldEditor.vue?vue&type=template&id=56325699&scoped=true&"
import script from "./EnrollmentFieldEditor.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentFieldEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56325699",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
